import moment from 'moment'

export function formatEndDateFilter(date) {
  return moment(date).set({ hours: 23, minutes: 59, seconds: 59 }).format('YYYY-MM-DDTHH:mm:ssZ')
}
